import { render, staticRenderFns } from "./PropertiesForRent.vue?vue&type=template&id=06b0f2ec&scoped=true&"
import script from "./PropertiesForRent.vue?vue&type=script&lang=ts&"
export * from "./PropertiesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0f2ec",
  null
  
)

export default component.exports